function splitClassName(className) {
  return className.split(' ').filter(Boolean);
}

export default splitClassName;
